var _classCallCheck = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _defineProperty = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _slicedToArray = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("E:\\headzgang-new\\StealingHearts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.ThetaDropConnect = {});
})(this, function (exports) {
  'use strict';

  var SCOPE = 'read_user_account';
  var API_BASE = 'https://api.thetadrop.com';

  var sendGETRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
      var response, _yield$response$json, body;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("".concat(API_BASE).concat(url));

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();

            case 5:
              _yield$response$json = _context.sent;
              body = _yield$response$json.body;
              return _context.abrupt("return", body);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendGETRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var objectToQueryParams = function objectToQueryParams(obj) {
    return Object.keys(obj).map(function (key) {
      var value = obj[key];

      if (Array.isArray(value)) {
        return value.map(function (v) {
          return key + '=' + v;
        }).join('&');
      }

      return key + '=' + value;
    }).join('&');
  };

  var fetchNFTs = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tpsId, filters) {
      var queryString, url, url1, _yield$sendGETRequest, nfts, packs, types, user_profiles, tps_profiles, tnt721_tokens;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryString = objectToQueryParams(filters); // const url = `/nft/${tpsId}/list?number=1000&expand=token_id&expand=content_id&expand=content_id.user_id&expand=content_id.user_id&expand=content_id.user_id.tps_id&expand=owner_id&expand=owner_id.tps_id&${queryString}`;

              url = "/nft/".concat(tpsId, "/list?number=1000&expand=token_id&expand=content_id&expand=content_id.user_id&expand=content_id.user_id&expand=content_id.user_id.tps_id&expand=owner_id&content_id=type_jgzuu9ypadin368adt3mtdix3wi");
              url1 = '/nft/user_b12yxgihkeupv26zz7sifvy4fb4/list?number=1000&expand=token_id&expand=content_id&expand=content_id.user_id&expand=content_id.user_id&expand=content_id.user_id.tps_id&expand=owner_id';
              _context2.next = 5;
              return sendGETRequest(url);

            case 5:
              _yield$sendGETRequest = _context2.sent;
              nfts = _yield$sendGETRequest.nfts;
              packs = _yield$sendGETRequest.packs;
              types = _yield$sendGETRequest.types;
              user_profiles = _yield$sendGETRequest.user_profiles;
              tps_profiles = _yield$sendGETRequest.tps_profiles;
              tnt721_tokens = _yield$sendGETRequest.tnt721_tokens;
              return _context2.abrupt("return", {
                nfts: nfts,
                packs: packs,
                types: types,
                user_profiles: user_profiles,
                tps_profiles: tps_profiles,
                tnt721_tokens: tnt721_tokens
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchNFTs(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _fetchUser = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tpsId) {
      var url, _yield$sendGETRequest2, tps_profiles, user_profiles;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "/user/".concat(tpsId, "?expand=tps_id");
              _context3.next = 3;
              return sendGETRequest(url);

            case 3:
              _yield$sendGETRequest2 = _context3.sent;
              tps_profiles = _yield$sendGETRequest2.tps_profiles;
              user_profiles = _yield$sendGETRequest2.user_profiles;
              return _context3.abrupt("return", {
                id: user_profiles[0]['id'],
                tps_id: tpsId,
                username: tps_profiles[0]['username'],
                display_name: tps_profiles[0]['display_name'],
                avatar_url: tps_profiles[0]['avatar_url']
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchUser(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  function getQueryParams(search) {
    search = search || window.location.search;
    if (!search || search.indexOf('=') === -1) return {};
    var hashes = search.slice(search.indexOf('?') + 1).split('&');
    return hashes.reduce(function (params, hash) {
      var _hash$split = hash.split('='),
          _hash$split2 = _slicedToArray(_hash$split, 2),
          key = _hash$split2[0],
          val = _hash$split2[1];

      return Object.assign({}, params, _defineProperty({}, key, decodeURIComponent(val)));
    }, {});
  }

  function getThetaDropAuthURL(appId, redirectURL, scope) {
    return "https://www.thetadrop.com/external-login" + "?app_id=".concat(appId) + "&redirect_url=".concat(redirectURL) + "&scope=".concat(scope);
  }

  var urlToAuthCredentials = function urlToAuthCredentials(url) {
    var params = getQueryParams(url);
    if (!Object.keys(params).length || params.sns_id === undefined || params.oauth2_token === undefined) return null;
    return {
      snsId: params.sns_id,
      oauth2Token: params.oauth2_token
    };
  };

  var ThetaDropConnect = /*#__PURE__*/function () {
    function ThetaDropConnect() {
      _classCallCheck(this, ThetaDropConnect);

      this.isConnected = false;
      this._snsId = null;
      this._oauth2Token = null;
    }

    _createClass(ThetaDropConnect, [{
      key: "connectViaRedirect",
      value: function connectViaRedirect(clientId, redirectUri) {
        var url = getThetaDropAuthURL(clientId, redirectUri, SCOPE);
        window.location.href = url;
      }
    }, {
      key: "connectViaPopup",
      value: function connectViaPopup(clientId, redirectUri) {
        var _this = this;

        var url = getThetaDropAuthURL(clientId, redirectUri, SCOPE);
        var authWin = window.open(url, "thetadrop-auth", "height=590, width=665");
        return new Promise(function (resolve, reject) {
          var onStorageUpdate = function onStorageUpdate(e) {
            if (e.key !== 'theta-drop-connect.auth-url' || e.newValue === null) return;
            var url = e.newValue;
            var authCredentials = urlToAuthCredentials(url);

            if (authCredentials === null) {
              return resolve();
            }

            if (authWin) {
              authWin.close();
            }

            window.removeEventListener('storage', onStorageUpdate);
            _this._snsId = authCredentials.snsId;
            _this._oauth2Token = authCredentials.oauth2Token;
            _this.isConnected = true;
            return resolve(authCredentials);
          };

          window.addEventListener('storage', onStorageUpdate);
        });
      }
    }, {
      key: "finishConnectViaRedirect",
      value: function finishConnectViaRedirect() {
        var _this2 = this;

        return new Promise(function (resolve, reject) {
          var authCredentials = urlToAuthCredentials(window.location.href);

          if (authCredentials === null) {
            return resolve();
          }

          _this2._snsId = authCredentials.snsId;
          _this2._oauth2Token = authCredentials.oauth2Token;
          _this2.isConnected = true;
          return resolve(authCredentials);
        });
      }
    }, {
      key: "fetchUser",
      value: function fetchUser() {
        if (this.isConnected) {
          return _fetchUser(this._snsId);
        }

        return new Error('User not connected');
      }
    }, {
      key: "fetchUserNFTs",
      value: function fetchUserNFTs(filters) {
        if (this.isConnected) {
          console.log(this._snsId, 'sns');
          return fetchNFTs(this._snsId, filters);
        }

        return new Error('User not connected');
      }
    }, {
      key: "checkUserIsOwner",
      value: function () {
        var _checkUserIsOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(nftFilters) {
          var _yield$fetchNFTs, nfts;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!this.isConnected) {
                    _context4.next = 6;
                    break;
                  }

                  _context4.next = 3;
                  return fetchNFTs(this._snsId, nftFilters);

                case 3:
                  _yield$fetchNFTs = _context4.sent;
                  nfts = _yield$fetchNFTs.nfts;
                  return _context4.abrupt("return", Boolean(nfts && nfts.length > 0));

                case 6:
                  return _context4.abrupt("return", new Error('User not connected'));

                case 7:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function checkUserIsOwner(_x5) {
          return _checkUserIsOwner.apply(this, arguments);
        }

        return checkUserIsOwner;
      }()
    }]);

    return ThetaDropConnect;
  }();

  exports.getThetaDropAuthURL = getThetaDropAuthURL;
  exports.ThetaDropConnect = ThetaDropConnect;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});